var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"res-video-wra"},[_c('video-player',{ref:"video",staticClass:"video-js vjs-big-play-centered",attrs:{"options":_vm.playerOptions,"playsinline":true},on:{"playing":_vm.onPlaying,"ended":_vm.onEnd}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0549d632","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/uAttach/uVideoAttach.vue
// module id = null
// module chunks = 